import {videoTypes} from "./type";
import {BaseAction} from "../../actions/base";

const types = videoTypes;

const path = `iot/video`;

const base = new BaseAction(types);

export const getVideoDatas = () => (dispatch) => {
    return base.getDatas(path, dispatch);
};

export const getDeletedVideoDatas = () => (dispatch) => {
    return base.getDatas(`${path}/deleted`, dispatch);
};

export const getVideoData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}`, dispatch);
};

export const getDeletedVideoData = (id) => (dispatch) => {
    return base.getData(`${path}/${id}/deleted`, dispatch);
};

export const addVideoData = (newData) => (dispatch) => {
    return base.addData(path, dispatch, newData);
};

export const editVideoData = (id, newData) => (dispatch) => {
    return base.editData(`${path}/${id}`, dispatch, newData);
};

export const deleteVideoData = (id) => (dispatch) => {
    return base.deleteData(`${path}/${id}`, dispatch, id);
};

export const restoreVideoData = (id) => (dispatch) => {
    return base.restoreData(`${path}/${id}/restore`, dispatch, id);
};

export const hardDeleteVideoData = (id) => (dispatch) => {
    return base.hardDeleteData(`${path}/${id}/confirmdelete`, dispatch, id);
};
